import $ from 'jquery';

const $testimonialsSlider = $('.testimonial__slider');
$testimonialsSlider.slick({
	autoplay: true,
	autoplaySpeed: 4000,
	arrows: true,
	dots: false,
});
